import { Route } from '@angular/router';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { provideOivViewer } from '@mobi/oiv-viewer-ng-jslib';
import { B2C, PAGE_URL_PATH, URL_PATH, languageResolver } from '@mobi/oiv-viewer-utils-ng-jslib';

export const appRoutes: Route[] = [
    {
        path: URL_PATH.AVB,
        redirectTo: PAGE_URL_PATH.NOT_FOUND,
        pathMatch: 'full',
    },
    {
        path: PAGE_URL_PATH.NOT_AVAILABLE,
        resolve: { language: languageResolver },
        data: { app: B2C },
        loadComponent: () => import('@mobi/oiv-viewer-ng-jslib').then(m => m.NotAvailableComponent),
    },
    {
        path: PAGE_URL_PATH.NOT_FOUND,
        resolve: { language: languageResolver },
        data: { app: B2C },
        loadComponent: () => import('@mobi/oiv-viewer-ng-jslib').then(m => m.NotFoundPageComponent),
    },
    {
        path: URL_PATH.AVB + '/:urlName',
        resolve: { language: languageResolver },
        data: { app: B2C },
        providers: provideOivViewer,
        loadChildren: () => import('@mobi/oiv-viewer-ng-jslib').then(m => m.MainLayoutModule),
    },
    {
        path: ':language',
        resolve: { language: languageResolver },
        data: { app: B2C },
        children: [
            {
                path: URL_PATH.AVB + '/:urlName',
                data: { approvalMode: false },
                providers: [provideOivViewer],
                loadChildren: () => import('@mobi/oiv-viewer-ng-jslib').then(m => m.MainLayoutModule),
            },
            {
                path: PAGE_URL_PATH.NOT_FOUND,
                loadComponent: () => import('@mobi/oiv-viewer-ng-jslib').then(m => m.NotFoundPageComponent),
            },
            {
                path: PAGE_URL_PATH.NOT_AVAILABLE,
                loadComponent: () => import('@mobi/oiv-viewer-ng-jslib').then(m => m.NotAvailableComponent),
            },
        ],
    },
    {
        path: '',
        redirectTo: PAGE_URL_PATH.NOT_FOUND,
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: PAGE_URL_PATH.NOT_FOUND,
        pathMatch: 'full',
    },
];
